import React from 'react';
import {
  MasonryButtonRenderer,
  MasonryButtonRendererProps,
} from '@leagueplatform/masonry-renderers';
import { StackLayout } from '@leagueplatform/genesis-core';

export const MasonrySidebarButtonRenderer = (
  props: MasonryButtonRendererProps,
) => (
  <StackLayout>
    <MasonryButtonRenderer
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  </StackLayout>
);
